import {
    EDIT_PASSWORD_SUCCESS,
    EDIT_PASSWORD_FAIL,
    EDIT_PASSWORD_REQUEST
} from "../../constants/actions";

const initialState = {
  loading: false,
  newPass: false,
  error: false
};

const editProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EDIT_PASSWORD_SUCCESS:
      return {
        loading: false,
        newPass: true,
        error: false,
      };
    case EDIT_PASSWORD_FAIL:
      return {
        loading: false,
        newPass: false,
        error: true,
      };
    default:
      return state;
  }
};

export default editProfileReducer;
